import React from 'react';
import { Link } from 'react-router-dom';

export class Welcome extends React.Component {
  render () {
    return (
      <div className="container container_bg">
        <div className="content">
          <h1 className="title"><strong>欢迎使用</strong> 批量ETH or TOKEN 转账</h1>
          <p className="description">
            Desc youtube视频如何使用多发送者。
          </p>
          <p>
            已经准备好JSON或CSV了吗?
          </p>
          <Link className="button button_next" to='/1'>进行JSON或CSV</Link>

          <p>
            继续为JSON / CSVTransaction向导。使用UI构建地址和平衡列表。
          </p>
          <Link className="button button_next" to='/1'>对事务进行向导</Link>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Welcome.js